import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { MaxOccupancyViewModel } from 'models';

import { UitkCardTextSegment } from 'uitk-react-cards';
import { UitkHeading, UitkText } from 'uitk-react-text';

interface RoomMaxOccupancySegmentProps {
  maxOccupancy: MaxOccupancyViewModel;
}

export const RoomMaxOccupancySegment = ({ maxOccupancy }: RoomMaxOccupancySegmentProps) => {
  if (!maxOccupancy) {
    return null;
  }

  const { description } = maxOccupancy;

  return (
    <>
      {description && (
        <UitkCardTextSegment data-stid="room-info-max-occupancy">
          <UitkHeading level={3} size={400} data-stid="room-info-max-occupancy-title">
            <LocalizedText message="hotels.infosite.roomInfoDialog.sleeps.title" />
          </UitkHeading>
          <UitkText size={300} theme="secondary" dataTestId="room-info-max-occupancy-description">
            {description}
          </UitkText>
        </UitkCardTextSegment>
      )}
    </>
  );
};
